export default __webpack_public_path__ + "static/media/service-Engineering-Science.0c1e528d.jpg";